export default "__VITE_ASSET__CHlHuUfP__"